import Head from '@/components/layout/Head';

const Haendlerkonditionen = () => {
  return (
    <>
      <Head
        title="PayPal Händlerkonditionen 2025 - Spezielle Gebühren | paycal.org"
        description="Informationen zu PayPal Händlerkonditionen 2025. Erfahren Sie mehr über vergünstigte Gebühren für Händler mit hohem Transaktionsvolumen."
        canonical="https://paycal.org/haendlerkonditionen"
      />
      <div className="container mx-auto px-4 py-8">
        <article className="prose max-w-none">
          <h1>PayPal Händlerkonditionen 2025</h1>

          <h2>Gestaffelte Gebührenmodelle</h2>
          <p>
            PayPal bietet Händlern mit hohem Transaktionsvolumen vergünstigte 
            Konditionen an. Die Gebühren staffeln sich nach dem monatlichen 
            Verkaufsvolumen.
          </p>

          <h2>Voraussetzungen</h2>
          <p>
            Um von den Händlerkonditionen zu profitieren, müssen bestimmte 
            Voraussetzungen erfüllt sein. Dazu gehört ein nachweisbares 
            Transaktionsvolumen über einen bestimmten Zeitraum.
          </p>

          <h2>Gebührenübersicht für Händler</h2>
          <div className="overflow-x-auto">
            <table className="min-w-full">
              <thead>
                <tr>
                  <th>Monatliches Volumen</th>
                  <th>Gebührensatz</th>
                  <th>Fixgebühr</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>bis 2.000 €</td>
                  <td>2,49%</td>
                  <td>0,35 €</td>
                </tr>
                <tr>
                  <td>2.000 € - 5.000 €</td>
                  <td>2,19%</td>
                  <td>0,35 €</td>
                </tr>
                <tr>
                  <td>5.000 € - 25.000 €</td>
                  <td>1,99%</td>
                  <td>0,35 €</td>
                </tr>
                <tr>
                  <td>über 25.000 €</td>
                  <td>1,79%</td>
                  <td>0,35 €</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Additional sections about merchant conditions */}
        </article>
      </div>
    </>
  );
};

export default Haendlerkonditionen;